export const activityEnum = [
    {
        stateId: "PENDING_SIGNUP",
        stateName: "待报名"
    },
    {
        stateId: "SIGNING_UP",
        stateName: "报名中"
    },
    {
        stateId: "PENDING_ACTIVITY",
        stateName: "待开始"
    },
    {
        stateId: "IN_PROGRESS",
        stateName: "活动中"
    },
    {
        stateId: "COMPLETED",
        stateName: "完成"
    },
]
